///ts:ref=PandaConsole
/// <reference path="../console/PandaConsole.ts"/> ///ts:ref:generated
namespace GlobalInstanceChecker {
	type ItemType = {getIsValid:()=>boolean, getName:()=>string};
	var list:Array<ItemType> = [];
	
	export function watch(item:ItemType) {
		list.push(item);
	}

	export function check():void {
		for (let item of list) {
			if (item.getIsValid()) {
				//PandaConsole.errorUncritical(new PandaError('Valid leaked iterator ' + item.getName()));
			}
		}
		list = [];
	}
}